module.exports = __webpack_public_path__ + "img/logo_univision.09babd6a.png";